import {
  Flex,
  FlexColumn,
  InfoTooltip,
  PasswordField,
  TextField,
  TextFieldList,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { Typography } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { PowerBiForm as PowerBiFormFields } from 'shared/types';

const PowerBiForm = ({
  formMethods,
}: {
  formMethods: UseFormReturn<PowerBiFormFields, any, undefined>;
}) => {
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
    control,
  } = formMethods;

  return (
    <>
      <FormControls.InputWrapper>
        <TextField
          {...register('powerBiConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Connection name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.powerBiConnectionName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <TextField
          {...register('powerBiTenant', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Your Microsoft tenant"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.powerBiTenant?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <TextField
          {...register('powerBiClientId', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Client ID"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.powerBiClientId?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <PasswordField
          {...register('powerBiClientSecret', {
            required: requiredLabel,
          })}
          label="Client secret"
          isFormValueDirty={dirtyFields.powerBiClientSecret}
          clearFormValue={() => setValue('powerBiClientSecret', '')}
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.powerBiClientSecret?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.FieldsWrapper sx={{ gap: '8px !important' }}>
        <Flex sx={{ gap: 1, alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 500 }}>Workspaces</Typography>
          <InfoTooltip
            size={16}
            title="If no workspaces are specified, all available workspaces will be used"
          />
        </Flex>
        <FlexColumn>
          <Controller
            name="powerBiWorkspaces"
            control={control}
            render={({ field }) => (
              <TextFieldList
                {...field}
                sx={{ maxHeight: '300px', overflow: 'auto' }}
                buttonText="Add workspace"
                placeholder="workspace"
              />
            )}
          />
        </FlexColumn>
      </FormControls.FieldsWrapper>
    </>
  );
};

export default PowerBiForm;
